export const questKeys = {
  all: ["quests"] as const,
  quest: () => [...questKeys.all, "detail"] as const,
  lists: () => [...questKeys.all, "list"] as const,
  list: (filters: { name?: string | null; offset: number; limit: number }) =>
    [...questKeys.lists(), filters] as const,
  detail: (id: number) => [...questKeys.quest(), id] as const,
};

export const questMutationKeys = {
  create: ["createQuest"] as const,
  update: ["updateQuest"] as const,
  createOrUpdate: ["createOrUpdateQuest"] as const,
};
